'use client';
import { useState } from 'react';
import style from './style.module.scss';
import { navData } from '@/constants';
import { NavDataProps } from '@/constants/navData';
import Link from 'next/link';
import burger from '@/public/burger.svg';
import Image from 'next/image';
import classNames from 'classnames';
import { BurgerMenuWrapper } from '../burger-menu';

export const Navigation = () => {
  // const [active, setActive] = useState<boolean>(false);

  // const handleChangeActive = () => {
  //   return setActive(false);
  // };
  return (
    <nav className={style.nav}>
      <div
        // onClick={() => {
        //   setActive(!active);
        // }}
        className={style.mobile}>
        <BurgerMenuWrapper />
        {/* <Image src={burger} width={25} height={25} alt="mobile-menu" /> */}
      </div>
      <ul
        className={classNames(style.list)}
        >
        {navData?.map((elem: NavDataProps, index: number) => {
          return (
            <li  key={index} className={style.item}>
              <Link href={elem?.link}>{elem.title}</Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
